import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { Store } from 'components/common/types/Store.types';
import { getPublisherVioohCentralConfiguration } from 'modules/api/publisher';
import { cancelFunctions } from 'utils/cancelFunctions';

type UseAssetTemplateV2EnabledResult = {
  isAssetTemplateV2Enabled: boolean | null;
};

export const useAssetTemplateV2Enabled = (): UseAssetTemplateV2EnabledResult => {
  const environmentId = useSelector((state: Store) => state.environment.environmentId);
  const [isAssetTemplateV2Enabled, setIsAssetTemplateV2Enabled] = useState<boolean | null>(null);

  useEffect(() => {
    setIsAssetTemplateV2Enabled(null);

    const loadConfig = async (): Promise<void> => {
      try {
        const getConfig = await getPublisherVioohCentralConfiguration({ envId: environmentId, cancelFunctions });

        if (!getConfig) {
          setIsAssetTemplateV2Enabled(false);
          return;
        }

        const isV2AssetTemplateEnabled = getConfig.v2_asset_template_enabled === 'true';

        setIsAssetTemplateV2Enabled(isV2AssetTemplateEnabled);
      } catch {
        setIsAssetTemplateV2Enabled(false);
      }
    };

    loadConfig();
  }, [environmentId]);

  return { isAssetTemplateV2Enabled };
};
